import { css } from '@emotion/react'
import { generateUrl } from '../../utils'
import { Divider, Typography } from '../base-ui'
import { MediaQuery } from '../base-ui/Utility'
import { EditorTypography } from '../webpage'
import { Image, ItemList, Tag, LinkItem } from './'
import { useTranslation } from 'next-i18next'

function BlogPost({
    cover,
    title,
    content,
    permalinl,
    tags = [],
    readMore = []
}) {
    const { t } = useTranslation(['common'])
    const style = css`
        display: block;
        padding: 1rem;
        width: 100%;
        height: 100%;
        .image {
            position: relative;
            margin: 1rem 0;
            height: 200px;
            margin-top: 2rem;
        }
        ${MediaQuery('md', 'min')} {
            .image {
                height: 400px;
            }
        }
    `
    return (
        <div css={style}>
            <Typography type="h1" fontSize="2.3rem">
                {title}
            </Typography>
            <div className="image">
                <Image src={cover} alt="" layout="fill" />
            </div>
            <EditorTypography
                type="p"
                fontWeight="Normal"
                fontSize="1.1rem"
                lineHeight="2rem"
            >
                <div dangerouslySetInnerHTML={{ __html: content }}></div>
            </EditorTypography>
            <Divider />
            {permalinl && (
                <>
                    <span>{t('لینک کوتاه', { ns: 'common' })}: </span>
                    <span
                        style={{
                            cursor: 'pointer',
                            color: 'blue',
                            fontSize: '0.9em'
                        }}
                        onClick={(e) => {
                            navigator.clipboard.writeText(permalinl)
                            e.preventDefault()
                            return false
                        }}
                    >
                        {permalinl}
                    </span>
                    <Divider />
                </>
            )}
            <ItemList
                title={
                    <Typography type="h5" className="my-4 pb-2">
                        {t('تگ ها', { ns: 'common' })}:
                    </Typography>
                }
                gap="0.5rem"
            >
                {tags.map((t) => (
                    <Tag key={t} href={generateUrl(t, 'tag')}>
                        {t}
                    </Tag>
                ))}
            </ItemList>
            <Divider />
            <ItemList
                direction="vertical"
                title={
                    <Typography type="h4">
                        {t('بیشتر بخوانید', { ns: 'common' })}
                    </Typography>
                }
                style="margin-bottom: 2rem;"
            >
                {readMore.map((rm, idx) => (
                    <LinkItem key={idx} href={generateUrl(rm, 'news')}>
                        {rm.title}
                    </LinkItem>
                ))}
            </ItemList>
        </div>
    )
}

export default BlogPost
